module.exports = __webpack_public_path__ + "static/media/kyte_logo.11186112.svg";